import React from 'react';
import { Helmet } from 'react-helmet-async';
import { favicon, ItemMetaTags } from './';
import { strippedContent } from '../../lib/helpers';

const escapeSpecialChars = (text) => {
  const charsMap = {
    amp: '&',
    lt: '<',
    gt: '>',
    quot: '"',
    '#039': "'",
    '#x27': "'",
  };
  return text.replace(/&([^;]+);/g, (m, c) => charsMap[c]);
};

const descriptionParts = [
  'plek voor je dagelijkse entertainment.',
  "Met de leukste filmpjes en foto's voor als je even geen zin hebt in werk, studie of menselijk contact.",
  'Hoofdsponsor van Nederlandse zolderkamers.',
];

const mainDescription = 'De ' + descriptionParts.join(' ');

const googlizeDescription = (description) => {
  let descr = description;
  const additionalSentences = [
    '| Dumpert is ' + descriptionParts[0],
    descriptionParts[1],
    descriptionParts[2],
  ];

  while (descr.length < 160 && additionalSentences.length > 0) {
    descr += ' ' + additionalSentences.shift();
  }

  return descr;
};

export const MetaTags = ({ title, item, embedded }) => {
  const itemDescription =
    item && item.description && escapeSpecialChars(strippedContent(item.description));

  return (
    <>
      <Helmet defer={false}>
        <html />
        <title>{item && item.title ? `DUMPERT - ${item.title}` : title || 'DUMPERT'}</title>
        {
          <meta
            name='description'
            content={itemDescription ? googlizeDescription(itemDescription) : mainDescription}
          />
        }
        {!item && <meta property='og:type' content='website' />}
        {!item && <meta property='og:url' content='https://www.dumpert.nl/' />}
        <meta property='og:locale' content='nl_NL' />
        <meta name='dcterms.rights' content='MediaHuis Nederland B.V.' />
        <link
          href='https://www.mediahuis.nl/algemene-voorwaarden/gebruikersvoorwaarden-uitgaven/general-terms-of-use-for-mediahuis-publications/'
          rel='license'
        />
        <meta property='fb:pages' content='332145270132218' />
        <meta property='fb:app_id' content='227370684433724' />
        {favicon}
      </Helmet>
      {item && (
        <ItemMetaTags
          item={item}
          embedded={embedded}
          description={itemDescription || mainDescription}
        />
      )}
    </>
  );
};
